<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/woreportrecord/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.productionNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')">
            <el-select filterable :clearable="true" v-model="yt.conditions.procedureCode">
              <el-option v-for="(item, index) in descName" :key="index" :label="item.desc" :value="item.code"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('tibaoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('caozuoren')">
            <el-input v-model="yt.conditions.operator"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifoubulu')">
            <el-select v-model="yt.conditions.type">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :type="'organization'" :idsPath.sync="yt.conditions.orgIds" :ids.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('biaoqiantiaomahao')">
            <el-input v-model="yt.conditions.labelBarcodeNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baogongdanhao')">
            <el-input v-model="yt.conditions.woReportRecordNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.conditions.remark"></el-input>
          </el-form-item>
          <template v-if="'jschicheng' === customerInfo.code">
            <el-form-item :label="$t('rengongjilukaishishijian')">
              <yi_time_input type="datetimerange" :start.sync="yt.conditions.manualRecordStartTimeStart" :end.sync="yt.conditions.manualRecordStartTimeEnd"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('rengongjilujieshushijian')">
              <yi_time_input type="datetimerange" :start.sync="yt.conditions.manualRecordEndTimeStart" :end.sync="yt.conditions.manualRecordEndTimeEnd"></yi_time_input>
            </el-form-item>
          </template>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ createTimeStart: begin(), createTimeEnd: end() })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('gongdanbaogongbulu', null, 'w1')" type="primary" v-if="utils.checkPower('web_production_management_work_report_wo_additional')">
          {{ $t('gongdanbaogongbulu') }}
        </el-button>
        <el-button size="mini" @click="importShow = !importShow" plain v-if="utils.checkPower('web_production_management_work_report_batchWoReport')">
          {{ $t('piliangdaorubaogong') }}
        </el-button>
      </template>
      <template #shifoubulu="scope">
        <span v-if="scope.row.type == 0">
          {{ $t('fou') }}
        </span>
        <span v-if="scope.row.type == 1">
          {{ $t('shi') }}
        </span>
      </template>
      <template #buliangshuliang="scope">
        <span @click="
          yt.showEditDialog('buliangmingxi', scope.row, 'w2', beforeShowEditDialog);
        getBadQuantityRecordItem();
        " style="color: #419FFF">
          {{ scope.row.badQuantity }}
        </span>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="
              yt.showEditDialog('baogongbulu', scope.row, 'w1', beforeShowEditDialog);
            getEquipmentId();
            " v-if="utils.checkPower('web_production_management_work_report_create')">
              {{ $t('baogongbulu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="
              yt.showEditDialog('buliangbulu', scope.row, 'w2');
            getEquipmentId();
            getDefectTab();
            " v-if="utils.checkPower('web_production_management_work_report_badRecordCreate')">
              {{ $t('buliangbulu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="showBarcodeDialog(scope.row)" v-if="utils.checkPower('web_production_management_work_report_label_barcode')">{{ $t('biaoqiantiaomahao') }}</el-button>
          </el-col>
          <el-col :span="0.1">
            <!-- 修改备注 -->
            <el-button type="text" @click="yt.showEditDialog('xiugaibeizhu', scope.row, 'w3')" v-if="utils.checkPower('web_production_management_work_report_update_remark')">{{ $t('xiugaibeizhu') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/production/woreportrecord/delete')" v-if="utils.checkPower('web_production_management_work_report_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/custom/honghuo/woReportRecord/delete')" v-if="utils.checkPower('web_production_management_work_report_delete_honghuo')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <template #gongshi="scope">
        <div v-if="scope.row.manualRecordStartTime && scope.row.manualRecordEndTime">{{ ((scope.row.manualRecordEndTime - scope.row.manualRecordStartTime) / 3600 / 1000).toFixed(2) }}h</div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="yt.exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 报工补录 -->
      <template v-if="yt.editObj.action == 'baogongbulu'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('gongxubianma/miaoshu')" required>
              <el-input disabled v-model="procedureName"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('shebeimingcheng')" required>
              <yi_cross_select disabled multiple :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId"> </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('baogongbuluriqi')" required>
              <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.reportDate"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('baogongbulubanci')" required>
              <el-select filterable :clearable="true" v-model="yt.editObj.shiftId">
                <el-option v-for="(item, index) in equipmentList" :key="index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
              <yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('jihuashuliang')">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.planQuantity" size="mini"> </el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.leftProductionQuantity" size="mini"> </el-input>
            </el-form-item>
            <el-form-item :label="$t('dangbanbaogongshuliang')" required>
              <yi_number_input :min="1" :type="number" :start.sync="yt.editObj.quantity"></yi_number_input>
              <span style="color: #F56C6C">({{ $t('liangpin') }}+{{ $t('buliangpin') }})</span>
            </el-form-item>
            <el-form-item :label="$t('dangbanbuliangshuliang')">
              <el-input v-model="yt.editObj.badQuantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="yt.editObj.remark" maxlength="100" show-word-limit> </el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/woreportrecord/create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '报工记录-报工补录' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 不良补录 -->
      <template v-if="yt.editObj.action == 'buliangbulu'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
              <yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('gongxubianma/miaoshu')">
              <el-input disabled v-model="procedureName"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('shebeimingcheng')">
              <yi_cross_select disabled multiple :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId"> </yi_cross_select>
            </el-form-item>
          </el-form>
          <template>
            <div style="color: #303133;font-weight: bold">{{ $t('bencibulubuliangpinshu') }}：{{ accumulate }}</div>
            <el-tabs v-model="topActive" @tab-click="handleClick">
              <!-- @tab-click="handleClick" -->
              <el-tab-pane v-for="(top, index) in tab" :key="top.name" :label="top.name" :name="top.name">
                <div style="display: flex;justify-content: space-between;">
                  <div v-if="top.defectCodeVOS.length > 0" style="flex: 1;display:flex;flex-wrap:wrap;justify-content:flex-start;align-items:center;">
                    <div v-for="(item, i) in top.defectCodeVOS" :key="i" style="width:50%;">
                      <div style="display: flex;align-items:center;justify-content: space-between;margin-bottom:10px;margin-right: 100px;">
                        <div style="flex: 1;text-align: right;padding-right: 8px;">{{ item.desc }}</div>
                        <el-input-number v-model="item.badQuantity" :min="0" size="mini"> </el-input-number>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/wo/bad/quantity/record/create', beforeAdd)" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '报工记录-不良补录' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!--不良明细-->
      <template v-if="yt.editObj.action == 'buliangmingxi'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
              <yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('gongxubianma/miaoshu')">
              <el-input disabled v-model="procedureName"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('shebeimingcheng')">
              <yi_cross_select disabled multiple :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId"> </yi_cross_select>
            </el-form-item>
          </el-form>
          <template>
            <div style="color: #303133;font-weight: bold;display: flex;flex-wrap: nowrap">
              <div>{{ $t('buliangpinshu') }}：{{ badAccumulate }}</div>
              <div style="margin-left: 16px">({{ $t('weiluruyuanyin') }}：{{ yt.editObj.badQuantity - badAccumulate }})</div>
            </div>
            <el-tabs v-model="tabsActive" @tab-click="handleClick">
              <el-tab-pane v-for="(tops, index) in defectTab" :key="tops.levelOneDefectTypeName" :label="tops.levelOneDefectTypeName" :name="tops.levelOneDefectTypeName">
                <div style="display: flex;justify-content: space-between;">
                  <div v-if="tops.defectCodeDTOList.length > 0" style="flex: 1;display:flex;flex-wrap:wrap;justify-content:flex-start;align-items:center;">
                    <div v-for="(items, i) in tops.defectCodeDTOList" :key="i" style="width:50%;">
                      <div style="display: flex;align-items:center;justify-content: space-between;margin-bottom:10px;margin-right: 100px;">
                        <div style="flex: 1;text-align: right;padding-right: 8px;">{{ items.defectDesc }}</div>
                        <div>{{ items.defectCodeBadQuantity }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </template>
      <!--工单报工补录-->
      <template v-if="yt.editObj.action == 'gongdanbaogongbulu'">
        <div class="dialog-scroller">
          <el-form :model="conditions" :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shengchangongdanhao')" required>
              <yi_cross_select :max="1" :component="'web_quality_management_work_order'" :ids.sync="conditions.woId" @getItems="getItem"> </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('gongxumiaoshu')" required>
              <el-input disabled v-model="conditions.procedureDesc"></el-input>
            </el-form-item>
            <el-form-item :label="$t('baogongbuluriqi')" required>
              <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="conditions.reportDate"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('baogongbulubanci')" required>
              <el-select :disabled="eqDisabled" filterable :clearable="true" v-model="conditions.shiftId">
                <el-option v-for="(item, index) in ShiftByEquipmentList" :key="index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
              <el-input disabled v-model="materialIdName"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('jihuashuliang')">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="conditions.planQuantity" size="mini"> </el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="conditions.leftProductionQuantity" size="mini"> </el-input>
            </el-form-item>
            <el-form-item :label="$t('dangbanbaogongshuliang')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="conditions.shiftReportQuantity" size="mini"> </el-input>
              <!--              <el-input-number  :precision="0" :min="1" :step="1" :controls="false" size="mini" v-model="conditions.shiftReportQuantity" >-->
              <!--              </el-input-number>-->
              <br />
              <span style="color: #F56C6C">({{ $t('liangpin') }}+{{ $t('buliangpin') }})</span>
            </el-form-item>
            <el-form-item :label="$t('dangbanbuliangshuliang')" required>
              <el-input-number :precision="0" :min="0" :step="1" :controls="false" size="mini" v-model="conditions.shiftBadQuantity"> </el-input-number>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="conditions.remarks" maxlength="400"> </el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="loading" size="mini" @click="reportWork" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '报工记录-工单报工补录' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 修改备注 -->
      <template v-if="yt.editObj.action == 'xiugaibeizhu'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" maxlength="400"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="loading" size="mini" @click="updateRemark" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '报工记录-工单报工补录' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 批量导入 -->
    <importExcel :show.sync="importShow" />
    <!-- 标签条码号 -->
    <el-dialog v-dialog-drag :show-close="true" :title="$t('shengchangongdanhao') + '：' + yt.editObj.productionNo" :visible.sync="isShowBarcodeDialog" append-to-body="append-to-body" width="980px">
      <template v-if="isShowBarcodeDialog">
        <div class="dialog-scroller">
          <label_barcode :reportRecord="yt.editObj"></label_barcode>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import importExcel from '@@/pages/web/production_management/work_report/import_excel';
import label_barcode from '@@/pages/web/production_management/work_report/label_barcode';

export default {
  name: 'web_production_management_work_report_list',
  components: {
    importExcel,
    label_barcode
  },
  data() {
    return {
      loading: false,
      importShow: false,
      selectId: null,
      eqDisabled: true,
      conditions: {
        shiftBadQuantity: 0,
        shiftReportQuantity: null
      },
      descName: [], //工序管理
      procedureDesc: '', //工序描述
      ShiftByEquipmentList: [], //班次数据
      materialIdName: null,
      list: [],
      tab: [],
      defectTab: [],
      num: '',
      defectCodeName: [],
      defectCodeDTOListName: [],
      topActive: '',
      tabsActive: '',
      codeName: null,
      procedureName: null,
      equipmentId: null,
      equipmentList: [],
      isShowBarcodeDialog: false,
      customerInfo: {},
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'productionNo',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 130
        },
        {
          label: 'baogongdanhao',
          prop: 'woReportRecordNo',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mouldNo',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mouldName',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'materialCode',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName',
          width: 130
        },
        {
          label: 'guige',
          prop: 'materialObject.spec',
          width: 130
        },
        {
          label: 'gongxugongdan',
          prop: 'procedureNo'
        },
        {
          label: 'gongxumiaoshu',
          prop: 'procedureDesc',
          width: 130
        },

        {
          label: 'baogongshuliang',
          prop: 'quantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'goodQuantity',
          width: 130
        },
        {
          label: 'buliangshuliang',
          prop: 'badQuantity',
          type: 'slot',
          width: 130
        },
        {
          label: 'jiqijilushuliang',
          prop: 'machineQuantity',
          width: 130
        },
        {
          label: 'chayishuliang',
          prop: 'diffQuantity',
          width: 130
        },
        //补充列
        {
          label: 'moqiangshu',
          prop: 'cavity',
          width: 130
        },
        //补充列
        {
          label: this.$t('biaozhunzhouqi(miao/mu)'),
          prop: 'standardCycle',
          width: 180
        },
        //补充列
        {
          label: this.$t('pingjunzhouqi(miao/mu)'),
          prop: 'cycle',
          width: 180
        },
        {
          label: 'baogongriqi',
          prop: 'reportDate',
          type: 'time',
          width: 180,
          format: 'YYYY-MM-DD'
        },

        {
          label: 'baogongbanci',
          prop: 'shiftName',
          width: 130
        },
        {
          label: 'tibaoshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'jiqijilukaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'jiqijilujieshushijian',
          prop: 'endTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'rengongjilukaishishijian',
          prop: 'manualRecordStartTime',
          type: 'time',
          width: 180,
          show: false
        },
        {
          label: 'rengongjilujieshushijian',
          prop: 'manualRecordEndTime',
          type: 'time',
          width: 180,
          show: false
        },
        {
          label: 'gongshi',
          type: 'slot',
          width: 80,
          show: false
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname',
          width: 130
        },
        {
          label: 'xiezuoren',
          prop: 'collaborator',
          width: 150
        },
        {
          label: 'shifoubulu',
          prop: 'type',
          type: 'slot',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    'yt.isShowEditDialog': {
      handler(n, o) {
        if (n == false) {
          this.conditions.woId = '';
          this.conditions.shiftReportQuantity = '';
          this.conditions.shiftId = '';
          this.conditions.procedureDesc = '';
          this.conditions.reportDate = '';
          this.materialIdName = '';
          this.conditions.planQuantity = '';
          this.conditions.leftProductionQuantity = '';
          this.eqDisabled = true;
          this.conditions.shiftBadQuantity = 0;
        }
        console.log('vvvdsdd', n);
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    // this.$set(this.conditions, 'reportDate', this.begins())
    this.customerInfo = this.store.state.customer;
    console.log('客户', this.customerInfo);
    this.customShowColumn();

    setTimeout(() => {
      this.getRrocedure();
      this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, 'createTimeStart', this.begin());
      this.$set(this.yt.conditions, 'createTimeEnd', this.end());
      this.yt.list = [];
      this.utils.event_hub.$on('WEB_WORK_REPORT_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
  },
  computed: {
    accumulate() {
      let total = 0;
      if (this.tab.length > 0) {
        for (let i = 0; i < this.tab.length; i++) {
          let all = this.tab[i]['defectCodeVOS'];
          if (all.length > 0) {
            for (let j = 0; j < all.length; j++) {
              if (all[j].badQuantity !== null && all[j].badQuantity !== undefined) {
                total += all[j].badQuantity;
              }
            }
          }
        }
      }
      return total;
    },
    //不良明细
    badAccumulate() {
      let total = 0;
      if (this.defectTab.length > 0) {
        for (let i = 0; i < this.defectTab.length; i++) {
          let all = this.defectTab[i]['defectCodeDTOList'];
          if (all.length > 0) {
            for (let j = 0; j < all.length; j++) {
              if (all[j].defectCodeBadQuantity !== null && all[j].defectCodeBadQuantity !== undefined) {
                total += all[j].defectCodeBadQuantity;
              }
            }
          }
        }
      }
      return total;
    }
  },

  destroyed() {
    // 取消对bus事件的监听
    this.utils.event_hub.$off('WEB_WORK_REPORT_REFRESH');
  },

  methods: {
    updateRemark() {
      let params = {
        id: this.yt.editObj.id,
        remark: this.yt.editObj.remark
      };
      this.http
        .post('/web/production/woreportrecord/update', params)
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    showEditRemarkDialog(row) { },
    // 只有江苏驰诚的客户才显示人工记录开始时间和人工记录结束时间
    customShowColumn() {
      if ('jschicheng' === this.customerInfo.code) {
        this.showColumn('rengongjilukaishishijian');
        this.showColumn('rengongjilujieshushijian');
        this.showColumn('gongshi');
      }
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        const c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    reportWork() {
      this.loading = true;
      let params = {
        shiftId: this.conditions.shiftId,
        curShiftQuantity: this.conditions.shiftReportQuantity,
        woProcedureId: this.selectId,
        curShiftBadQuantity: this.conditions.shiftBadQuantity,
        reportDate: this.conditions.reportDate,
        remark: this.conditions.remarks,
        type: 1
      };
      this.http
        .post('/web/production/wo/reportValid', params)
        .then(res => {
          this.loading = false;

          this.result = res.data.code;

          if (this.result == 0) {
            this.getReport();
          }
          if (this.result == 1) {
            let value = res.data.value;
            this.$message.error(this.$t('报工间隔限制' + value + this.$t('小时，请稍后再报工')));
          }
          if (this.result == 2) {
            let value = res.data.value;
            this.$confirm('上次报工时间是' + this.dateFormat(value) + '是否确认提交报工?', this.$t('baogongqueren'), {
              confirmButtonText: this.$t('queding'),
              cancelButtonText: this.$t('quxiao'),
              type: 'warning'
            })
              .then(() => {
                this.getReport();
              })
              .catch(() => { });
          }
        })
        .catch(error => {
          this.loading = false;

          this.$message.error(this.$t(error));
        })
        .finally(() => []);
    },
    getReport() {
      this.loading = true;
      let params = {
        shiftId: this.conditions.shiftId,
        curShiftQuantity: this.conditions.shiftReportQuantity,
        woProcedureId: this.selectId,
        curShiftBadQuantity: this.conditions.shiftBadQuantity,
        reportDate: this.conditions.reportDate,
        remark: this.conditions.remarks,
        type: 1
      };
      this.http
        .post('/web/production/wo/report', params)
        .then(res => {
          this.loading = false;

          this.$message.success(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
          // this.conditions.shiftReportQuantity = null
          // this.conditions.shiftBadQuantity = 0
          // this.yt.editObj.shiftId=[]
        })
        .catch(error => {
          this.loading = false;

          this.$message.error(this.$t(error));
        });
    },
    getItem(row) {
      this.selectId = row.id;
      if (row) {
        this.disabled = false;
        this.eqDisabled = false;
        this.equipmentId = row.equipmentId;
        // this.procedureDesc = row.procedureDesc
        this.materialIdName = row.material.code + '/' + row.material.name;
        this.conditions = row;
        // console.log('fffffwww',this.materialIdName)
        this.getShiftByEquipmentId();
      }
      this.conditions.shiftBadQuantity = 0;
      // console.log('this.selectId',this.selectId)
    },
    //工序管理
    getRrocedure() {
      this.http.get('/web/craft/basic/work/procedure/list ').then(res => {
        this.descName = res.data;
      });
    },

    //获取班次
    getShiftByEquipmentId() {
      this.http
        .get('/web/setting/shift/getShiftByEquipmentId', {
          params: {
            equipmentId: this.equipmentId,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.ShiftByEquipmentList = res.data;
        });
    },
    // getEquipmentId() {
    //   this.http.get('/web/setting/shift/getCurrentShiftByEquipmentId', {
    //     params: {
    //       equipmentId: this.equipmentId,
    //       pageNum: 1,
    //       pageSize: 1000
    //     }
    //   }).then(res => {
    //     this.ShiftByEquipmentList = res.data
    //
    //   })
    //
    // },

    beforeGet(params) {
      params['createTimeStart'] = this.begin();
      params['createTimeEnd'] = this.end();
      return params;
    },

    begins() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()).getTime();
      return begin;
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = date.getTime();
      return end;
    },
    beforeAdd(params, url) {
      console.log('params', params);
      params.reportRecordId = params.id;
      params.defectCodeList = [];
      let levelOneDefectTypeId = this.tab
        .map(item => {
          return item.id;
        })
        .join(',');
      params['levelOneDefectTypeId'] = parseInt(levelOneDefectTypeId);
      if (this.tab.length > 0) {
        for (let i = 0; i < this.tab.length; i++) {
          let all = this.tab[i]['defectCodeVOS'];
          for (let j = 0; j < all.length; j++) {
            let defectCodeId = all[j]['id'];
            let defectDesc = all[j]['desc'];
            let badQuantity = all[j]['badQuantity'];
            let allItem = {
              defectCodeId: defectCodeId,
              defectDesc: defectDesc,
              defectCodeBadQuantity: badQuantity,
              defectCodeBadQuantity: badQuantity == null || badQuantity == undefined ? 0 : badQuantity
            };

            params.defectCodeList.push(allItem);
          }
        }
      }
      const list = [];
      for (let i = 0; i < this.tab.length; i++) {
        const item = [];
        for (let j = 0; j < this.tab[i]['defectCodeVOS'].length; j++) {
          const res = params.defectCodeList.filter(item => {
            return item.defectCodeId === this.tab[i]['defectCodeVOS'][j].id;
          });
          if (res.length > 0) {
            item.push(res[0]);
          }
        }

        list.push({
          defectCodeVOS: item,
          levelOneDefectTypeId: this.tab[i]['id']
        });
      }
      params.defectCodeList = list;
      return params;
    },
    handleClick(tab, event) { },
    getEquipmentId() {
      this.http
        .get('/web/setting/shift/getShiftByEquipmentId', {
          params: {
            equipmentId: this.equipmentId,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.equipmentList = res.data;
          console.log('kkkk', this.equipmentList);
        });
    },
    // /basic/defectType/getDefectTypeAndCode
    getDefectTab() {
      this.http
        .get('/web/basic/defectType/getDefectTypeAndCode', {
          params: {
            level: 1
          }
        })
        .then(res => {
          this.tab = res.data || [];
          this.tab.forEach((val, index, val_arr) => {
            if (Array.isArray(val_arr[index].defectCodeVOS) && val_arr[index].defectCodeVOS.length > 0) {
              val_arr[index].defectCodeVOS.forEach((el, i, el_arr) => {
                this.defectCodeName = el_arr;
              });
            }
          });
          console.log('44444', this.defectCodeName);
          if (!this.tab.length == '') {
            this.topActive = this.tab[0]['name'];
          }
          // if (!this.tab.length == '') {
          //   this.topActive = this.tab[0]['levelOneDefectTypeId']
          // }
          console.log('ddddd', this.tab);
        });
    },
    //不良明细
    getBadQuantityRecordItem() {
      this.http
        .get('/web/production/woreportrecord/getBadQuantityRecordItem', {
          params: {
            woReportRecordId: this.yt.editObj.id,
            woProcedureId: this.yt.editObj.woProcedureId
          }
        })
        .then(res => {
          this.defectTab = res.data || [];
          this.defectTab.forEach((val, index, val_arr) => {
            // console.log('defectCodeDTOListName1',el)
            if (Array.isArray(val_arr[index].defectCodeVOS) && val_arr[index].defectCodeVOS.length > 0) {
              val_arr[index].defectCodeDTOList.forEach((el, i, el_arr) => {
                this.defectCodeDTOListName = el_arr;
              });
            }
          });
          if (!this.defectTab.length == '') {
            this.tabsActive = this.defectTab[0]['levelOneDefectTypeName'];
          }
        });
    },
    beforeShowEditDialog(editObj) {
      console.log('editObjeditObj', editObj);
      this.equipmentId = editObj.equipmentId;
      this.procedureName = editObj.procedureCode + ' / ' + editObj.procedureDesc;
      return editObj;
    },
    exportExcel() {
      let params = this.yt.conditions;
      this.yt.exportLoading = true;
      return this.http
        .get('/web/report/export/wo_report_record_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.yt.exportLoading = false;
        });
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()).getTime();
      return end;
    },
    // 重置
    clear() {
      this.yt.conditions = {
        createTimeStart: this.begin(),
        createTimeEnd: this.end()
      };
      this.yt.list = [];
    },
    showBarcodeDialog(row) {
      if (row) {
        this.yt.editObj = this.utils.copy(row);
      } else {
        this.yt.editObj = {};
      }
      this.isShowBarcodeDialog = true;
    }
  }
};
</script>
